import { useState } from "react";
import { Modal } from "../Modal";
import {
    CreateInstitutionModalContainer,
    CreateInstitutionModalContentContainer,
    CreateInstitutionModalTitle,
    CreateInstitutionModalContentWrapper,
    Form,
    Button,
    Input,
} from "./CreateInstitutionModal.styles";

// Language Context
import { useLanguage } from "../../../core/translations/LanguageContext";

// Translations
import { CreateInstitutionModalTranslations } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import { SupportedLanguage } from "../../../core/translations/supportedLanguages";

const TRANSLATIONS: Record<
    SupportedLanguage,
    CreateInstitutionModalTranslations
> = {
    en: enTranslations,
    de: deTranslations,
};
interface CreateInstitutionModalProps {
    onRequestClose: () => void;
    onSubmit: (e: any) => void;
    setFormData: (e: any) => void;
    formData: {
        name: string;
    };
}
export const CreateInstitutionModal = ({
    onRequestClose,
    onSubmit,
    setFormData,
    formData,
}: CreateInstitutionModalProps) => {
    const { language } = useLanguage();
    //@ts-ignore
    const translations = TRANSLATIONS[language];
    return (
        <Modal onRequestClose={onRequestClose}>
            <CreateInstitutionModalContainer>
                <CreateInstitutionModalContentContainer>
                    <CreateInstitutionModalContentWrapper>
                        <Form>
                            <CreateInstitutionModalTitle>
                                {translations.title}
                            </CreateInstitutionModalTitle>
                            <Input
                                name="institute_name"
                                //@ts-ignore
                                onChange={(e) =>
                                    setFormData({ name: e.target.value })
                                }
                                value={formData?.name}
                            />

                            <Button
                                backgroundColorHex="#102c46"
                                onClick={(e) => onSubmit(e)}
                            >
                                {translations.createButtonText}
                            </Button>
                        </Form>
                    </CreateInstitutionModalContentWrapper>
                </CreateInstitutionModalContentContainer>
            </CreateInstitutionModalContainer>
        </Modal>
    );
};

export default CreateInstitutionModal;
